import React, { FC } from 'react';
import MuiCard, { CardProps as MuiCardProps } from '@material-ui/core/Card';
import MuiCardContent, { CardContentProps as MuiCardContentProps } from '@material-ui/core/CardContent';
import MuiCardHeader, { CardHeaderProps as MuiCardHeaderProps } from '@material-ui/core/CardHeader';
import MuiCardActions, { CardActionsProps as MuiCardActionsProps } from '@material-ui/core/CardActions';
import MuiCardActionArea, { CardActionAreaProps as MuiCardActionAreaProps } from '@material-ui/core/CardActionArea';

import styled from 'styled-components';
import { Uds } from '../../types';

export type CardProps = Uds<
  MuiCardProps & {
    fullSize?: boolean;
  }
>;

export type CardContentProps = Uds<MuiCardContentProps & {}>;

export type CardHeaderProps = Uds<MuiCardHeaderProps & {}>;

export type CardActionsProps = Uds<MuiCardActionsProps & {}>;

export type CardActionAreaProps = Uds<MuiCardActionAreaProps & {}>;

export const Card: FC<React.PropsWithChildren<CardProps>> = ({ dataTest, fullSize, ...props }) =>
  fullSize ? (
    <StyledFullSizeCard elevation={props.elevation ?? 0} data-test={dataTest} {...props} />
  ) : (
    <MuiCard data-test={dataTest} {...props} />
  );

const StyledFullSizeCard = styled(MuiCard)`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const CardHeader: FC<React.PropsWithChildren<CardHeaderProps>> = ({ dataTest, ...props }) => (
  <MuiCardHeader data-test={dataTest} {...props} />
);

export const CardContent: FC<React.PropsWithChildren<CardContentProps>> = ({ dataTest, ...props }) => (
  <MuiCardContent data-test={dataTest} {...props} />
);

export const CardActions: FC<React.PropsWithChildren<CardActionsProps>> = ({ dataTest, ...props }) => (
  <MuiCardActions data-test={dataTest} {...props} />
);

export const CardActionArea: FC<React.PropsWithChildren<CardActionAreaProps>> = ({ dataTest, ...props }) => (
  <MuiCardActionArea data-test={dataTest} {...props} />
);
